import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "error",
    initialState: null,
    reducers: {
        set: (state, action) => action.payload,
    },
});
